import { render, staticRenderFns } from "./Jumbo.vue?vue&type=template&id=4305269d&"
import script from "./Jumbo.vue?vue&type=script&lang=js&"
export * from "./Jumbo.vue?vue&type=script&lang=js&"
import style0 from "./Jumbo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports